import React from 'react';
import Table from './table';
import { useTranslation } from 'react-i18next';

const AppUserRole = () => {
  const { t } = useTranslation();
  
  return (
    <div className='space-y-5'>
      <h1 className='flex h-10 items-center justify-start text-xl md:text-2xl font-semibold'>{t('menu.userRole')}</h1>
      <Table t={t} />
    </div>
  );
};

export default AppUserRole;
